import { __extends } from "tslib";
import { CreateRecommenderConfigurationRequest, CreateRecommenderConfigurationResponse } from "../models/models_0";
import { deserializeAws_restJson1CreateRecommenderConfigurationCommand, serializeAws_restJson1CreateRecommenderConfigurationCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
/**
 * <p>Creates an Amazon Pinpoint configuration for a recommender model.</p>
 */
var CreateRecommenderConfigurationCommand = /** @class */ (function (_super) {
    __extends(CreateRecommenderConfigurationCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateRecommenderConfigurationCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    CreateRecommenderConfigurationCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PinpointClient";
        var commandName = "CreateRecommenderConfigurationCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: CreateRecommenderConfigurationRequest.filterSensitiveLog,
            outputFilterSensitiveLog: CreateRecommenderConfigurationResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateRecommenderConfigurationCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1CreateRecommenderConfigurationCommand(input, context);
    };
    CreateRecommenderConfigurationCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1CreateRecommenderConfigurationCommand(output, context);
    };
    return CreateRecommenderConfigurationCommand;
}($Command));
export { CreateRecommenderConfigurationCommand };
//# sourceMappingURL=CreateRecommenderConfigurationCommand.js.map